// The languages content can be tagged with: the six Celtic languages grouped by their linguistic
// root (Goidelic / Q-Celtic and Brythonic / P-Celtic), plus English. Order matters: Goidelic first
// (Irish, Scottish Gaelic, Manx), then Brythonic (Welsh, Cornish, Breton), then English.
//
// Kept in sync with the backend allowlist Item::SUPPORTED_LANGUAGES.

export type LanguageGroupKey = "goidelic" | "brythonic" | "other"

export interface Language {
  /** ISO code (also the value stored on the item). */
  code: string
  /** English name. */
  name: string
  /** Endonym (the language's own name). */
  nativeName: string
  group: LanguageGroupKey
}

export const LANGUAGES: Language[] = [
  { code: "ga", name: "Irish", nativeName: "Gaeilge", group: "goidelic" },
  { code: "gd", name: "Scottish Gaelic", nativeName: "Gàidhlig", group: "goidelic" },
  { code: "gv", name: "Manx", nativeName: "Gaelg", group: "goidelic" },
  { code: "cy", name: "Welsh", nativeName: "Cymraeg", group: "brythonic" },
  { code: "kw", name: "Cornish", nativeName: "Kernewek", group: "brythonic" },
  { code: "br", name: "Breton", nativeName: "Brezhoneg", group: "brythonic" },
  { code: "en", name: "English", nativeName: "English", group: "other" },
]

export interface LanguageGroup {
  key: LanguageGroupKey
  /** Label shown as the group heading in the picker (names the Celtic root). */
  label: string
  languages: Language[]
}

export const LANGUAGE_GROUPS: LanguageGroup[] = [
  {
    key: "goidelic",
    label: "Goidelic (Q-Celtic)",
    languages: LANGUAGES.filter((l) => l.group === "goidelic"),
  },
  {
    key: "brythonic",
    label: "Brythonic (P-Celtic)",
    languages: LANGUAGES.filter((l) => l.group === "brythonic"),
  },
  {
    key: "other",
    label: "Other",
    languages: LANGUAGES.filter((l) => l.group === "other"),
  },
]

export const LANGUAGE_BY_CODE: Record<string, Language> = Object.fromEntries(
  LANGUAGES.map((l) => [l.code, l])
)

export const SUPPORTED_LANGUAGE_CODES: string[] = LANGUAGES.map((l) => l.code)
